import React from 'react'
import classnames from 'classnames'
import { withSize } from 'react-sizeme'

import Card from '@material-ui/core/Card'
import withStyles from '@material-ui/core/styles/withStyles'
import CardMedia from '@material-ui/core/CardMedia'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'
import Collapse from '@material-ui/core/Collapse'
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import SvgIcon from '@material-ui/core/SvgIcon'

import WarningIcon from '@material-ui/icons/Warning'
import PlaceIcon from '@material-ui/icons/Place'
import DoneIcon from '@material-ui/icons/Done'
import StarIcon from '@material-ui/icons/Star'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import CommentIcon from '@material-ui/icons/Comment'
import ShareIcon from '@material-ui/icons/Share'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import RestoreIcon from '@material-ui/icons/Restore'

import green from '@material-ui/core/colors/green'
import amber from '@material-ui/core/colors/amber'

import EventOverview from './EventOverview'
import { EventHistoryDialog, EventTweetDialog } from '../containers'
import { Comment, SNSShareDialog, Word } from '../../../containers'
import { Link, useHistory } from 'react-router-dom'
import ConfirmDialog from '../../../components/Common/ConfirmDialog'
import { getRootURL, makePath } from '../../../lib'
import { authorType } from '../../../constants'
import AsyncContainer from '../../../containers/Common/AsyncContainer'
import { WID } from '../../../constants/Language';
import { useContext } from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { Auth0Context } from '../../../Parts/Auth0'
import { SettingsContext } from '../../../Parts/Settings'
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'

const GoogleMapReact = AsyncContainer(() => import(/* webpackChunkName: "google-map-react" */  'google-map-react')
  .then(module => module.default), { name: 'GoogleMapReact' });

const styles1 = theme => ({
  button: {
    color: theme.palette.grey[700],
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
})

class AttendOrInterestButtons extends React.Component {
  render() {
    const { classes, theme, settings, checkedAttend, checkedInterest, handleClickAttend, handleClickInterest } = this.props
    const styles = {
      attend : {
        color: checkedAttend ? green[700] : theme.palette.grey[700],
        borderColor: checkedAttend ? green[700] : theme.palette.common.white,
        fontWeight: checkedAttend ? 700 : 100
      },
      interest: {
        color: checkedInterest ? amber[700] : theme.palette.grey[700],
        borderColor: checkedInterest ? amber[700] : theme.palette.common.white,
        fontWeight: checkedInterest ? 700 : 100,
      }
    }
    if (settings) {
      return (
        <div>
          <Button
            variant='outlined'
            color={checkedAttend ? 'primary' : 'default'}
            className={classes.button}
            onClick={handleClickAttend}
            style={styles.attend}
          >
            <DoneIcon className={classes.icon}/>
            <Word wid={WID.EVENT_CARD.ATTEND_OR_INTEREST_BUTTONS.ATTEND}/>
          </Button>
          <Button
            variant='outlined'
            color={checkedInterest ? 'primary' : 'default'}
            className={classes.button}
            onClick={handleClickInterest}
            style={styles.interest}
          >
            <StarIcon className={classes.icon}/>
            <Word wid={WID.EVENT_CARD.ATTEND_OR_INTEREST_BUTTONS.INTEREST}/>
          </Button>
        </div>
      )
    }
    else {
      return (<div></div>)
    }
  }
}

AttendOrInterestButtons = withStyles(styles1, { withTheme: true })(AttendOrInterestButtons)

const styles2 = theme => ({
  badge: {
    textDecoration: 'none'
  },
  attendBadge: {
    top: 'auto',
    bottom: -2,
    right: -4,
    width: theme.spacing.unit * 2,
    height: theme.spacing.unit * 2,
    backgroundColor: green[700],
    border: `2px solid ${theme.palette.common.white}`,
  },
  interestBadge: {
    top: 'auto',
    bottom: -2,
    right: -4,
    width: theme.spacing.unit * 2,
    height: theme.spacing.unit * 2,
    backgroundColor: amber[700],
    border: `2px solid ${theme.palette.common.white}`,
  },
  badgeIcon: {
    fontSize: '0.5rem',
    color: theme.palette.common.white,
  },
})

const EventActionAvatars = withStyles(styles2, { withTheme: true })((props) => {
  const { classes, record } = props
  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext
  return (
    <CardActions>
      {record.attend && record.attend.map(user => {
        return user ? (
          <Badge
            key={user.userName}
            classes={{badge: classes.attendBadge}}
            className={classes.badge}
            badgeContent={<DoneIcon className={classes.badgeIcon}/>}
            component={Link}
            to={makePath(`/user/${user.userName}`, language)}
          >
            <CustomAvatar
              alt={user.displayName}
              name={user.displayName}
              src={user.avatarPhotoURL}
            />
          </Badge>
        ) : (<div key={0}></div>)
      })}
      {record.interest && record.interest.map(user => {
        return user ? (
          <Badge
            key={user.userName}
            classes={{badge: classes.interestBadge}}
            className={classes.badge}
            badgeContent={<StarIcon className={classes.badgeIcon}/>}
            component={Link}
            to={makePath(`/user/${user.userName}`, language)}
          >
            <CustomAvatar
              alt={user.displayName}
              name={user.displayName}
              src={user.avatarPhotoURL}
            />
          </Badge>
        ) : (<div key={0}></div>)
      })}
    </CardActions>
  )
})

const styles3 = theme => ({
  cardOverviewContent: {
    paddingRight: theme.spacing.unit,
    paddingBottom: 0,
  },
  cardDetailContent: {
    paddingTop: 0,
  },
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  flexBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  buttonBase: {
    marginRight: theme.spacing.unit,
  },
  cardWarningContent: {
    display: 'flex',
    backgroundColor: amber[700],
    padding: theme.spacing.unit * 2,
    margin: theme.spacing.unit * 2,
    borderRadius: theme.spacing.unit,
    alignItems: 'center',
    color: theme.palette.common.white,
  },
  warningIcon: {
    color: theme.palette.common.white,
    marginRight: theme.spacing.unit * 2,
  }
})

class EventContent extends React.Component {

  render() {
    const { classes, eventId, record, rev, settings, enabler, onClickDelete, language } = this.props
    
    return (
      <React.Fragment>
        <CardContent className={classes.cardOverviewContent}>
          <EventOverview
            record={record}
            type='cardTitle'
            fullAddress
            action={<EventCardMenu {...{eventId, record, rev, onClickDelete, settings, enabler, language}}/>}
          />
        </CardContent>
        {record.authorType === parseInt(authorType.PROVIDER, 10) ? (
          <CardContent className={classes.cardWarningContent}>
            <WarningIcon className={classes.warningIcon}/>
            <Typography color='inherit'><Word wid={WID.EVENT_CARD.EVENT_CONTENT.CAUTION_MESSAGE}/></Typography>
          </CardContent>
        ) : <div></div>}
        <CardContent className={classes.cardDetailContent}>
          <span dangerouslySetInnerHTML={{__html: record.detail}}></span>
        </CardContent>
      </React.Fragment>
    )
  }
}

EventContent = withStyles(styles3, { withTheme: true })(EventContent)

const styles4 = theme => ({
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  flexBox: {
    display: 'flex'
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
    [theme.breakpoints.up('sm')]: {
      marginRight: -8,
    },
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  totalCommentNumBox: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.grey[600],
    marginRight: theme.spacing.unit,
  },
})

class EventActions extends React.Component {
  state = { expanded: false, open: false }

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  }

  handleOpen = () => {
    this.setState({ open: true })
  }
  
  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { classes, size, attendOrInterestButtonsProps, totalCommentNum, record } = this.props
    const { expanded, open } = this.state
    return (
      <React.Fragment>
        <CardActions className={classes.flexSpaceBetween}>
          {size.width >= 400 ? (<AttendOrInterestButtons {...attendOrInterestButtonsProps}/>) : (<div></div>)}
          <div className={classes.flexBox}>
            {totalCommentNum !== undefined && (
              <div className={classes.totalCommentNumBox}>
                <CommentIcon className={classes.icon}/>
                <Typography variant='body2' color='inherit'>{totalCommentNum}</Typography>
              </div>
            )}
            <IconButton onClick={this.handleOpen}>
              <ShareIcon/>
            </IconButton>
            <IconButton
              className={classnames(classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={this.handleExpandClick}
            >
              <ExpandMoreIcon/>
            </IconButton>
          </div>
        </CardActions>
        <SNSShareDialog open={open} url={`${getRootURL()}/event/${record.id}`} onClose={this.handleClose} onOpen={this.handleOpen}/>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Comment id={record.commentId}/>
          </CardContent>
        </Collapse>
      </React.Fragment>
    )
  }
}

EventActions = withStyles(styles4, { withTheme: true })(EventActions)

const styles5 = theme => ({
  cardMapContent: {
    padding: 0,
    textAlign: 'center',
  },
  mapTitle: {
    color: theme.palette.grey[700],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 2,
  },
  googleMap: {
    width: '100%',
    height: 300,
    maxHeight: 300,
    backgroundColor: theme.palette.grey[700],
  },
  address: {
    color: theme.palette.grey[700],
    paddingBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
})

class GoogleMapCard extends React.Component {

  renderMarkers(map, maps) {
    const { record } = this.props
    new maps.Marker({
      position: {
        lat: record.latitude,
        lng: record.longitude,
      },
      map,
      title: record.address
    });
  }

  render() {
    const { classes, record } = this.props
    if (record.latitude !== undefined && record.longitude !== undefined) {
      return (
        <Card className={classes.card}>
          <CardContent className={classes.cardMapContent}>
            <Typography variant='title' className={classes.mapTitle}><PlaceIcon className={classes.icon}/>MAP</Typography>
            <Typography variant='body2' className={classes.address}>{record.address}</Typography>
            <div className={classes.googleMap}>
              <GoogleMapReact
                key={record.id}
                bootstrapURLKeys={{ key: 'AIzaSyAP2qIk5BA1ax9SfyR93cj8N5-LxwKmIBE' }}
                defaultCenter={{
                  lat: record.latitude,
                  lng: record.longitude,
                }}
                onGoogleApiLoaded={({map, maps}) => this.renderMarkers(map, maps)}
                defaultZoom={15}
                yesIWantToUseGoogleMapApiInternals={true}
              />
            </div>
          </CardContent>
        </Card>
      )
    }
    else {
      return (<div></div>)
    }
  }
}

GoogleMapCard = withStyles(styles5, { withTheme: true })(GoogleMapCard)

const styles6 = theme => ({
  iconButton: {
    marginTop: - theme.spacing.unit * 2,
  }
})

const EventCardMenu = withStyles(styles6, { withTheme: true })((props) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [openConfirm, setOpenConfirm] = useState(false)
  const [openHistory, setOpenHistory] = useState(false)
  const [openTweet, setOpenTweet] = useState(false)

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const history = useHistory()
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleOpenHistoryDialog = (event) => {
    setAnchorEl(null)
    setOpenHistory(true)
  }

  const handleCloseHistoryDialog = (event) => {
    setOpenHistory(false)
  }

  const handleOpenConfirmDialog = (event) => {
    setAnchorEl(null)
    setOpenConfirm(true)
  }

  const handleCloseConfirmDialog = (event) => {
    setOpenConfirm(false)
  }

  const handleOpenTweetDialog = (event) => {
    setAnchorEl(null)
    setOpenTweet(true)
  }

  const handleCloseTweetDialog = (event) => {
    setOpenTweet(false)
  }

  const handleClickDelete = (event) => {
    props.onClickDelete(history, language)
    setOpenConfirm(false)
  }

  const { classes, eventId, record, enabler } = props

  var options = [
    {
      visible: enabler.editMenuItem, 
      name: <Word wid={WID.EVENT_CARD_MENU.EDIT}/>,
      icon: <EditIcon />,
      props: {
        component: Link,
        to: makePath(`/event/register/${record.id}`, language)
      }
    },
    {
      visible: enabler.deleteMenuItem,
      name: <Word wid={WID.EVENT_CARD_MENU.DELETE}/>,
      icon: <DeleteIcon />,
      props: {
        onClick: handleOpenConfirmDialog
      }
    },
    {
      visible: enabler.tweetMenuItem,
      name: <Word wid={WID.EVENT_CARD_MENU.TWEET}/>,
      icon: 
        <SvgIcon viewBox="-5 -5 105 105" >
          <path d="M31.45,90.64c37.74,0,58.37-31.27,58.37-58.38,0-.89,0-1.77-.06-2.65A41.86,41.86,0,0,0,100,19a41.19,41.19,0,0,1-11.78,3.23,20.6,20.6,0,0,0,9-11.35,41.11,41.11,0,0,1-13,5,20.54,20.54,0,0,0-35,18.71A58.25,58.25,0,0,1,7,13.12a20.53,20.53,0,0,0,6.35,27.39A20.29,20.29,0,0,1,4,37.94a2.44,2.44,0,0,0,0,.27A20.53,20.53,0,0,0,20.47,58.32a20.49,20.49,0,0,1-9.26.35A20.54,20.54,0,0,0,30.38,72.92,41.21,41.21,0,0,1,4.89,81.7,41.69,41.69,0,0,1,0,81.42a58.07,58.07,0,0,0,31.45,9.22" />
        </SvgIcon>,
      props: {
        onClick: handleOpenTweetDialog
      }
    },
    {
      visible: enabler.historyMenuItem,
      name: <Word wid={WID.EVENT_CARD_MENU.VERSION_HISTORY}/>,
      icon: <RestoreIcon />,
      props: {
        onClick: handleOpenHistoryDialog
      },
    },
  ]
  if (Object.keys(enabler).some(key => enabler[key] === true)) {
    return (
      <React.Fragment>
        <IconButton onClick={handleClick} className={classes.iconButton}>
          <MoreVertIcon/>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {options.map((option, index) => {
            if (option.visible === false) {
              return (<div key={option.name}></div>)
            }
            return (
              <MenuItem key={index} {...option.props}>
                <ListItemIcon>{option.icon}</ListItemIcon>
                <ListItemText inset primary={option.name}/>
              </MenuItem>
            )
          })}
        </Menu>
        <EventHistoryDialog
          id={eventId}
          open={openHistory}
          onClose={handleCloseHistoryDialog}
        />
        <ConfirmDialog
          open={openConfirm}
          title={<Word wid={WID.EVENT_CARD_MENU.DELETE_CONFIRM_DIALOG.TITLE}/>}
          content={<Word wid={WID.EVENT_CARD_MENU.DELETE_CONFIRM_DIALOG.CONTENT}/>}
          onOK={handleClickDelete}
          onClose={handleCloseConfirmDialog}
        />
        <EventTweetDialog
          open={openTweet}
          onClose={handleCloseTweetDialog}
          record={record}
        />
      </React.Fragment>
    )
  }
  else {
    return (<div></div>)
  }
})

const styles = theme => ({
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  card: {
    maxWidth: 640,
    margin: `0 auto ${theme.spacing.unit * 2}px auto`,
  },
})

function EventCard(props) {
  const { init, unmount } = props
  const { classes, eventId, rev, settings, size, record, totalCommentNum, checkedAttend, checkedInterest, enabler, handleClickAttend, handleClickInterest, handleClickDelete, language } = props

  const auth0Context = useContext(Auth0Context)
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (auth0Context.isAuthenticated && !isInitialized) {
      init()
      setIsInitialized(true)
    }
    return () => {
      unmount()
    }
  }, [auth0Context.isAuthenticated, isInitialized])

  const styles = {
    media: {
      height: size.width > 640 ? 360 : size.width * 360 / 640
    }
  }
  const attendOrInterestButtonsProps = { settings, checkedAttend, checkedInterest, handleClickAttend, handleClickInterest }
  const eventActions = { size, attendOrInterestButtonsProps, totalCommentNum, record }
  if (record) {
    return (
      <React.Fragment>
        <Card className={classes.card}>
          {record.thumbnail && (<CardMedia style={styles.media} image={record.thumbnail} title={record.name}/>)}
          <EventContent {...{eventId, record, settings, rev, enabler, onClickDelete: handleClickDelete, language}}/>
          {rev === undefined && (
            <React.Fragment>
              <EventActionAvatars record={record} language={language}/>
              {size.width < 400 && (<CardActions><AttendOrInterestButtons {...attendOrInterestButtonsProps}/></CardActions>)}
              <EventActions {...eventActions}/>
            </React.Fragment>
          )}
        </Card>
        <GoogleMapCard record={record}/>
      </React.Fragment>
    )
  }
  else {
    return (<div></div>)
  }
}

export default withStyles(styles, { withTheme: true })(withSize()(EventCard))


// WEBPACK FOOTER //
// ./src/Pages/Event/components/EventCard.js